import {
  Container,
  Heading,
  HStack,
  VStack,
  Text,
  Breadcrumb,
  BreadcrumbItem,
  Grid,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ExamMainData from "../../../containers/student/exams/exam-main-data";
import Layout from "../../../components/student/Layout/layout";
import { getExamsByChapterIdRequest } from "../../../modules/students-modules/exams/Actions";
import { withTranslation } from "react-i18next";

const ChapterExams = ({ t }) => {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo") || "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chapterExams = useSelector((state) => state.chapterExams.chapterExams);
  const isLoading = useSelector((state) => state.chapterExams.isLoading);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getExamsByChapterIdRequest(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (!returnTo) {
      try {
        sessionStorage.removeItem("edutopia_post_exam_redirect");
      } catch {
        /* ignore */
      }
    }
  }, [returnTo]);

  const handelSolveExamFun = (data) => {
    window.location.href = `/solve-exam/${data?.id}?name=${encodeURIComponent(data?.name || "")}`;
  };

  const handelCheckExamAnswersFun = (data) => {
    window.location.href = `/exam-result/${data?.id}?name=${encodeURIComponent(data?.name || "")}`;
  };

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" mb="165px" w="100%">
        <VStack
          spacing={8}
          h="100%"
          w="100%"
          my="100px"
          alignItems="flex-start"
        >
          <Breadcrumb>
            <BreadcrumbItem onClick={() => navigate("/exams/sections")}>
              <Text>{t("home.Exams")}</Text>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <Text>{searchParams.get("name")}</Text>
            </BreadcrumbItem>
          </Breadcrumb>

          <HStack w="100%">
            <Heading as="h3" color="main_1" textAlign="center" w="100%">
              {searchParams.get("name")}
            </Heading>
          </HStack>

          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
            gap={6}
            w="100%"
          >
            {chapterExams?.map((chapter) => (
              <ExamMainData
                key={chapter.id}
                exam={chapter}
                state={chapter?.right_answers == null ? "Pending" : "Solved"}
                solveExamFun={handelSolveExamFun}
                checkExamAnswersFun={handelCheckExamAnswersFun}
                returnTo={returnTo}
              />
            ))}
          </Grid>
        </VStack>
      </Container>
    </Layout>
  );
};

export default withTranslation()(ChapterExams);
